export class AdminSubscriptionCompanyCustomer {
  customerId: number

  name: string

  phone: string

  email: string

  cpf: string

  debitStatus: string

  ordersCount: number

  manualExternalOrdersCount: number

  totalSpentAmount: number

  manualExternalOrdersAmount: number

  manualExternalOrdersNetAmount: number

  lastOrderDate?: string

  constructor(data: Partial<AdminSubscriptionCompanyCustomer> = {}) {
    this.customerId = data.customerId ?? 0

    this.name = data.name ?? ""

    this.phone = data.phone ?? ""

    this.email = data.email ?? ""

    this.cpf = data.cpf ?? ""

    this.debitStatus = data.debitStatus ?? ""

    this.ordersCount = data.ordersCount ?? 0

    this.manualExternalOrdersCount = data.manualExternalOrdersCount ?? 0

    this.totalSpentAmount = data.totalSpentAmount ?? 0

    this.manualExternalOrdersAmount = data.manualExternalOrdersAmount ?? 0

    this.manualExternalOrdersNetAmount = data.manualExternalOrdersNetAmount ?? 0

    this.lastOrderDate = data.lastOrderDate
  }
}
